<template>
    <div>
        <el-card >
            <el-row>
                <el-col :span="24">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item>知识百科</el-breadcrumb-item>
                    <el-breadcrumb-item>节点列表</el-breadcrumb-item>
                </el-breadcrumb>
                </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row>
                <el-col :span="6">
                    <div>
                        <el-aside>
                            <el-input size="small" style="margin-bottom:12px;" placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
                        
                            <el-tree class="filter-tree" :data="data" :props="defaultProps"  :filter-node-method="filterNode" @node-click="handleNodeClick" ref="tree"></el-tree>
                        </el-aside>
                    </div>
                </el-col>
                <el-col :span="18">
                    <div>
                        <div :class="isShow==true?'show':'hidden'">
                            <h1>{{title}}</h1>
                            <div class="editContain">
                                <div class="demo-input-suffix inputTop">
                                    <div class="inputLabel">节点名称：</div>
                                    <el-input style="width:80%;float:right;" v-model="nodeModel.KNodeName" placeholder="请输入节点名称"></el-input>
                                </div>
                                <div class="demo-input-suffix inputTop">
                                    <div class="inputLabel">父级节点：</div>
                                    <el-input style="width:80%;float:right;" disabled v-model="nodeModel.KNodeParentName" placeholder="请输入父级节点"></el-input>
                                </div>
                                <div class="demo-input-suffix inputTop">
                                    <div class="inputLabel">排序：</div>
                                    <el-input style="width:80%;float:right;" v-model="nodeModel.Sort" placeholder="请输入排序"></el-input>
                                </div>
                                <div class="demo-input-suffix inputTop">
                                <div class="inputLabel">描述：</div>
                                <el-input style="width:80%;float:right;" v-model="nodeModel.Note" placeholder="请输入内容"></el-input>
                                </div>
                        </div>
                        <el-row :class="btnShow==true?'':'hidden'">
                                <el-button type="primary" size="small" @click="saveInfo()" round>保存</el-button>
                                <el-button type="primary" size="small"  @click="addChildren()" round>增加子节点</el-button>
                                <el-button type="danger" size="small" :class="btnShow==true?'':'hidden'" @click="deleteNode()" round>删除</el-button>
                        </el-row>
                        <el-row :class="btnShow== false?'':'hidden'">
                                <el-button type="primary" size="small" @click="saveChildInfo()" round>保存</el-button>
                        </el-row>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </el-card>
    </div>
    
</template>

<script>
  import { GetWikiNode,GetSingleNode,UpdateNode,InsertNode,DeleteKnowledge  } from "../../until/ZeusApiSDK/Logic/WikiLogic";
  import { timeFormate  } from "../../until/Common";
  import { Decrypt } from "../../until/ZeusApiSDK/Logic/CryptoLogic";
  import { GetGuid } from "../../until/ZeusApiSDK/Logic/HomeLogic";
  export default {
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      }
    },
    created() {
        this.getWikiNode();
    },
    methods: {
      filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },
      //获取树状结构列表
      getWikiNode:async function(){
        await GetWikiNode().then(res => {
          this.data=JSON.parse(res);
        });
      },
      //节点点击事件
      handleNodeClick:async function(data){
          this.isShow=true;//是否显示左边菜单
          this.btnShow=true;//按钮全部显示
          await GetSingleNode(data.id).then(res=>{
              this.nodeModel=res;
          });
      },
      //保存当前信息(编辑)
      saveInfo:function(){
          var _this=this;
          //根据id获取当前节点信息
           _this.$confirm('您确定保存当前操作吗？', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '保存',
                cancelButtonText: '取消'
            }).then(() => {
                //保存
                //获取当前节点信息并保存
                UpdateNode(_this.nodeModel.KNodeID,JSON.stringify(_this.nodeModel)).then(res=>{
                    if(res){
                        _this.$message({
                            type: 'success',
                            message: '更新成功'
                        });
                        //刷新树状结构
                        _this.getWikiNode();
                        _this.isShow=false;
                        //刷新当前页面
                        //_this.$router.go(0);
                    }else{
                        _this.$message({
                            type: 'error',
                            message: '更新失败'
                        });
                    }
                });
                
            }).catch(action => {
                //取消
            });
          
      },
      //添加子节点
      addChildren:async function(){
          this.title="添加子节点";
          //false只显示保存按钮
          this.btnShow=false;          
          //获取Guid
          await GetGuid().then(res=>{
              this.guid=res;
          });
          //获取当前时间
          var nowTimes=timeFormate(new Date());

          var userinfo = window.sessionStorage.getItem("userinfo");
          userinfo = JSON.parse(Decrypt(userinfo));
          this.currentUser = userinfo;
          this.nodeChildModel=this.nodeModel;
          //构造添加实体类
          this.nodeModel={
              KNodeID:this.guid,
              KNodeName:'',
              KNodeParentID:this.nodeChildModel.KNodeID,
              KNodeParentName:this.nodeChildModel.KNodeName,
              Sort:'',
              Note:'',
              KNodeAddUserID:this.currentUser.UserId,
              KNodeAddUserName:this.currentUser.TrueName,
              IsDelete:0,
              KNodeAddTime:nowTimes,
          };
      },
      
      //保存子节点信息
      saveChildInfo:function(){
          var _this=this;
          //根据id获取当前节点信息
           _this.$confirm('您确定保存当前操作吗？', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '保存',
                cancelButtonText: '取消'
            }).then(() => {
                //保存
                //获取当前节点信息并保存
                InsertNode(JSON.stringify(this.nodeModel)).then(res=>{
                    if(res){
                        _this.$message({
                            type: 'success',
                            message: '添加成功'
                        });
                        //刷新树状结构
                        _this.getWikiNode();
                        _this.isShow=false;
                        //刷新当前页面
                        //_this.$router.go(0);
                    }else{
                        _this.$message({
                            type: 'error',
                            message: '添加失败'
                        });
                    }
                });
                
            }).catch(action => {
                //取消
            });
      },
      //删除当前节点
      deleteNode:function(){
          var id=this.nodeModel.KNodeID;
          this.nodeModel.IsDelete=1;
          this.nodeModel.DeleteTime=timeFormate(new Date());
          
          this.$confirm('您确定删除当前节点吗？', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '保存',
                cancelButtonText: '取消'
            }).then(() => {
                //删除当前节点
                UpdateNode(id,this.nodeModel).then(res=>{
                    if(res){
                        this.$message({
                            type: 'success',
                            message: '删除成功'
                        });
                        //刷新树状结构
                        // this.getWikiNode();

                        //刷新树状结构
                        this.getWikiNode();
                        this.isShow=false;
                    }else{
                        this.$message({
                            type: 'error',
                            message: '删除失败'
                        });
                    }
                });
                
            }).catch(action => {
                //取消
            });
      }
    },

    data() {
      return {
        wiki:{},
        filterText: '',
        nowTime:'',
        title:'编辑',//标题
        guid:'',//Guid
        isShow:false,//是否显示右边栏目
        btnShow:true,//是否显示 增加子节点和删除按钮(默认显示)
        nodeModel:{},//点击节点时获取数据
        nodeChildModel:{},//添加子节点时使用
        nodeModelAdd:{},//添加时参数
        data:[],//树状结构数组
        currentUser:{},//当前用户信息
        defaultProps: {
          children: 'children',
          label: 'label'
        }
      };
    }
  };
</script>
<style lang="less" scoped>
.editContain{
    width:60%;
    margin-left:20%;
    margin-right:20%;
}
.inputTop{
    margin-top:20px;
    height:40px;
    margin:20px 20%;
}
.inputLabel{
    width:20%;
    float:left;
    line-height: 40px;
}
.show{
    display: block;
}
.hidden{
    display: none;;
}
</style>